export const CUSTOMER_SERVICE_PHONE = '(801) 981 - 5329';
export const MEMBER_SUPPORT_PHONE = '(801) 981 - 5328';
export const MEMBER_SUPPORT_URL = 'peakserve.com';
